import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message } from 'antd';
import * as Yup from 'yup';
import logo from '../../assets/images/logo.png';
import axios from 'axios';
import { API_ENDPOINT } from '../../constants/apiConstants';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { setAuth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setAuth({ token, userData: {} });
            navigate('/loading'); // Redirect to loading screen if token exists
        }
    }, [navigate]);

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const response = await axios.post(API_ENDPOINT + "/users/sign_in", {"user": values});
            if (response.status === 200) {
                const token = response.headers.authorization; // Assuming token is in the authorization header
                setLoading(false);
                localStorage.setItem('token', token); // Store token in localStorage
                setAuth({ token, userData: response.data }); // Update context
                navigate('/loading'); // Navigate to loading screen
            } else {
                throw new Error(`Request failed with status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Yup.ValidationError) {
                const errorDetails = error.inner.map(err => ({
                    name: err.path,
                    errors: [err.message],
                }));
                form.setFields(errorDetails);
            }
            setLoading(false);
            message.warning("Invalid credentials. Please try again.");
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#000000',
        }}>
            <Card style={{width: 300, textAlign: 'center'}}>
                <img src={logo} alt="Logo" style={{width: '80%', margin: '0 auto'}}/>
                <p style={{fontWeight: 'bold', marginTop: '10px', color: 'red'}}>
                    Who's ready for the best fucking night of their lives?!
                </p>
                <Form
                    name="login"
                    initialValues={{remember: true}}
                    onFinish={(values) => handleSubmit(values)}
                    autoComplete="off"
                    style={{marginTop: '20px'}} // Add some spacing between the subheader and the form
                >
                    <Form.Item
                        name="email"
                        rules={[{required: true, message: 'Email is required'}]}
                    >
                        <Input placeholder="Email"/>
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{required: true, message: 'Password is required'}]}
                    >
                        <Input.Password placeholder="Password"/>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{width: '100%'}} loading={loading}>
                            Log in
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default Login;
